import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full w-full" }
const _hoisted_2 = { class: "__setup-target-smart __section shadow-sm bg-white overflow-hidden" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "__section__header font-semibold text-neutral-600 p-6 border-b" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-600" }, "Thành phần của mục tiêu"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 font-normal leading-5 text-sm mt-2" }, " Mục tiêu mặc định gồm có Lĩnh Vực và Nội Dung. Bạn có thể tuỳ chỉnh các mục sau đây để thiết lập các thành phần khác cho mục tiêu. ")
], -1)
const _hoisted_4 = { class: "__section__content" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 text-neutral-500 font-normal" }, " Mức độ hỗ trợ ", -1)
const _hoisted_8 = { class: "input-group flex-nowrap flex items-center justify-between p-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 text-neutral-500 font-normal" }, " Cơ sở hợp lý của mục tiêu ", -1)
const _hoisted_10 = { class: "input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 text-neutral-500 font-normal" }, " Chiến lược cho mục tiêu ", -1)
const _hoisted_12 = { class: "input-group flex-nowrap flex items-center justify-between p-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 text-neutral-500 font-normal" }, " Quy trình thực hiện mục tiêu ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwitchButton = _resolveComponent("SwitchButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_SwitchButton, {
              value: _ctx.enable_goal_assistance_level,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enable_goal_assistance_level) = $event))
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_SwitchButton, {
              value: _ctx.enable_goal_reason,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.enable_goal_reason) = $event))
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_SwitchButton, {
              value: _ctx.enable_goal_strategy,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.enable_goal_strategy) = $event))
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_SwitchButton, {
              value: _ctx.enable_goal_process,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.enable_goal_process) = $event))
            }, null, 8, ["value"])
          ])
        ])
      ])
    ])
  ]))
}